import React from "react";
import { ComponentType } from "../../../constants";
import { useCurriculumSelector } from "../../../redux/hooks";
import { selectComponentBySlug } from "../../../redux/curriculum/selectors/curriculum";
import { Box } from "@mui/material";
import SidebarTabTitle from "../components/SidebarTabTitle";
import CoachComponentPreview from "../../program-component/CoachComponentPreview";
import { CheckInComponentContext } from "../../new-editor/hooks";
import { EditorElementView } from "../../new-editor/utils/editorUtils";
const PreviewTab = ({ slug }: { type: ComponentType; slug: string }) => {
  const component = useCurriculumSelector(selectComponentBySlug(slug));

  return (
    // TODO component logic should be rewritten for better handling
    // readonly mode, to avoid using contexts like here
    <CheckInComponentContext.Provider
      value={{ view: EditorElementView.Preview }}
    >
      <Box
        sx={{
          containerType: "inline-size",
          overflowX: "clip",
          overflowY: "auto",
          paddingInline: 2,
          pointerEvents: "none",
        }}
      >
        <SidebarTabTitle title="Preview" showIcon={false} />
        <CoachComponentPreview component={component} />
      </Box>
    </CheckInComponentContext.Provider>
  );
};

export default PreviewTab;
